<template>
    <div style="min-height:66vh;">
        <botao-nova-movimentacao
            :exibirLinhaDoTempo="exibirLinhaDoTempo"
            :exibirTooltipMovimentacao="exibirTooltipMovimentacao"
            @cadastrarMovimentacao="tratarEventoCadastrarMovimentacao"
        />
        <div v-if="exibirLinhaDoTempo">
            <linha-do-tempo
                :items="items"
                :orgaos="orgaos"
                @buscarOrgaos="buscarMovimentacao"
            />
        </div>
        <router-view
            :movimentacao="movimentacao"
            :tipo="tipo"
            :situacao="situacao"
            :orgaos="orgaos"
            @buscarMovimentacaoPorId="buscarMovimentacao"
            @fecharModalMovimentacao="cancelarMovimentacao"
            @atualizarMovimentacao="tratarEventoAtualizarMovimentacao"
            @enviarMovimentacao="tratarEventoEnviarMovimentacao"
            @tratarEventoDeletarMovimentacao="tratarEventoDeletarMovimentacao"
            @finalizarMovimentacaoBaixa="tratarEventoFinalizarMovimentacaoBaixa"/>
    </div>
</template>

<script>
    import BotaoNovaMovimentacao from './BotaoNovaMovimentacao'
    import LinhaDoTempo from './LinhaDoTempo'
    import {actionTypes} from '@/core/constants'
    import {mapActions} from 'vuex'

    export default {
        name: 'NovaMovimentacao',
        components: {BotaoNovaMovimentacao, LinhaDoTempo},
        data() {
            return {
                movimentacao: {},
                patrimonioId: null,
                orgaos: [],
                items: [],
                tipo: null,
                situacao: null,
                exibirLinhaDoTempo: false,
                exibirTooltipMovimentacao: false
            }
        },
        async mounted() {
            this.setarIdPatrimonio()
            await this.buscarPatrimonio()
            await this.buscarMovimentacoes()
        },
        methods: {
            ...mapActions([
                actionTypes.PATRIMONIO.VISUALIZAR_PATRIMONIO_POR_ID,
                actionTypes.MOVIMENTACAO.ATUALIZAR_MOVIMENTACAO,
                actionTypes.MOVIMENTACAO.CADASTRAR_MOVIMENTACAO,
                actionTypes.MOVIMENTACAO.BUSCAR_MOVIMENTACAO_POR_PATRIMONIO,
                actionTypes.MOVIMENTACAO.ENVIAR_MOVIMENTACAO,
                actionTypes.COMUM.BUSCAR_TODOS_ORGAOS,
                actionTypes.MOVIMENTACAO.DELETAR_MOVIMENTACAO,
                actionTypes.MOVIMENTACAO.BAIXA.FINALIZAR_MOVIMENTACAO_BAIXA,
                actionTypes.MOVIMENTACAO.BUSCAR_MOVIMENTACAO_POR_ID
            ]),
            setarIdPatrimonio() {
                this.patrimonioId = this.$route.params.id
            },
            async buscarPatrimonio() {
                await this.visualizarPatrimonioPorId(this.patrimonioId)
            },
            setarSituacaoMovimentacao(movimentacao) {
                this.situacao = movimentacao.situacao
            },
            async tratarEventoAtualizarMovimentacao(movimentacao) {
                this.movimentacao = await this.atualizarMovimentacao(movimentacao)
            },
            async tratarEventoCadastrarMovimentacao(tipo) {
                this.movimentacao = await this.cadastrarMovimentacao({
                    tipo: tipo,
                    idPatrimonio: this.$route.params.id
                })
                this.tipo = tipo
                this.setarSituacaoMovimentacao(this.movimentacao)
                await this.buscarOrgaos(this.movimentacao)
                await this.redirecionaParaModal()
            },
            async buscarMovimentacoes() {
                const resultado = await this.buscarMovimentacaoPorPatrimonio({idPatrimonio: this.$route.params.id})
                this.items = resultado.items
                this.deveExibirLinhaDoTempo()
                this.deveExibirTooltipMovimentacao()
            },
            async buscarMovimentacao(movimentacaoId) {
                this.movimentacao = await this.buscarMovimentacaoPorId(movimentacaoId)
                this.tipo = this.movimentacao.tipo
                await this.buscarOrgaos(this.movimentacao)
                this.setarSituacaoMovimentacao(this.movimentacao)
                await this.redirecionaParaModal()
            },
            deveExibirLinhaDoTempo() {
                this.exibirLinhaDoTempo = this.items.length !== 0
            },
            deveExibirTooltipMovimentacao() {
                if (this.exibirLinhaDoTempo) {
                    let ehMovimentacaoEmElaboracao = this.items.filter((item) => {
                        return item.situacao !== 'FINALIZADO' && item.situacao !== 'REJEITADO'
                    })
                    this.exibirTooltipMovimentacao = ehMovimentacaoEmElaboracao.length !== 0
                }
            },
            async tratarEventoEnviarMovimentacao(movimentacao) {
                await this.enviarMovimentacao(movimentacao)
                await this.cancelarMovimentacao()
            },
            async tratarEventoFinalizarMovimentacaoBaixa(movimentacao) {
                await this.finalizarMovimentacaoBaixa(movimentacao.id)
                await this.cancelarMovimentacao()
            },
            async cancelarMovimentacao() {
                await this.$router.push({
                    name: 'NovaMovimentacao',
                    params: {id: this.patrimonioId}
                })
                await this.buscarMovimentacoes()
            },
            async buscarOrgaos(movimentacao) {
                this.desabilitarLoadingGlobal()
                const resultado = await this.buscarTodosOrgaos(movimentacao.orgaoOrigem.id)
                this.orgaos = resultado.items
                this.habilitarLoadingGlobal()
            },
            async redirecionaParaModal() {
                if (this.tipo === 'BAIXA') {
                    await this.$router.push({
                        name: 'ModalMovimentacaoBaixa',
                        params: {movimentacaoId: this.movimentacao.id}
                    })
                } else {
                    await this.$router.push({
                        name: 'ModalMovimentacao',
                        params: {movimentacaoId: this.movimentacao.id}
                    })
                }
            },
            async tratarEventoDeletarMovimentacao() {
                await this.deletarMovimentacao(this.movimentacao.id)
                await this.cancelarMovimentacao()
            }
        }
    }
</script>
